import * as THREE from "three";
import Projects from "./Projects.js";
import Home from "./Home.js";
import Loader from "../utils/Loader.js";

export default class World {
  static instance;

  constructor() {
    // Check Instance
    if (World.instance) {
      return World.instance;
    }
    World.instance = this;

    // Variables
    this.canvas;
    this.renderer;

    this.sizes = {
      height: 0,
      width: 0,
    };

    this.renderProjects = false;
    this.renderHome = false;
    this.renderNavigation = true;

    this.Project = null;
    this.Home = null;
    this.Loader = new Loader();

    // ==== //
    // Tick //
    // ==== //
    const tick = () => {
      this.render();

      if (this.renderProjects) {
        this.Project.animateCamera();
      }

      window.requestAnimationFrame(tick);
    };
    tick();

    // ====== //
    // Resize //
    // ====== //
    window.addEventListener("resize", () => {
      this.updateSizes();
    });
  }

  render() {
    if (this.renderProjects) {
      if (this.renderNavigation) {
        this.renderer.render(this.Project.scene, this.Project.camera);
      }
    } else if (this.renderHome) {
      this.Home.render();
      this.renderer.render(this.Home.scene, this.Home.camera);
    }
  }

  updateCanvas() {
    this.sizes = {
      height: 0,
      width: 0,
    };
    this.canvas = document.getElementById("scene3D");

    // Clean Rendere
    if (this.renderer) {
      this.renderer.dispose();
      this.renderer.forceContextLoss();
    }

    // Create new Renderer
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      alpha: true,
    });
  }

  // ====== //
  // Resize //
  // ====== //
  updateSizes() {
    const bodySizes = document.body.getBoundingClientRect();

    // Avoid Phone over resize
    this.sizes = {
      height: window.innerHeight,
      width: window.innerWidth,
      bodyHeight: bodySizes.height,
      bodyWidth: bodySizes.width,
    };

    // Update renderer
    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    if (this.renderProjects) {
      this.Project.resize(this.sizes);
    } else if (this.renderHome) {
      this.Home.resize(this.sizes);
    }
  }

  // ======== //
  // Projects //
  // ======== //
  setupProject(projectList) {
    this.renderProjects = true;
    this.renderHome = false;

    if (!this.Project) {
      this.Project = new Projects(projectList);
    } else {
      this.Loader.close();
    }

    this.renderer.setClearColor(0xffffff, 0);
    this.renderer.shadowMap.enabled = true;

    return this.Project;
  }

  // ==== //
  // Home //
  // ==== //
  setupHome() {
    this.renderProjects = false;
    this.renderHome = true;

    if (!this.Home) {
      this.Home = new Home();

      // if(this.devMode){
      //   this.addFlowfieldGui()
      // }
    } else {
      this.Home.particles.refresh();
      this.Loader.close();
    }

    this.Home.setNavigation(this.canvas);
    return this.Home;
  }
}
